// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"hb_wrapper__28XOB","dash":"hb_dash__23BLk","half":"hb_half__Ht0Dg","white":"hb_white__2-8-f"};